const getPropsForGroup = (group: any, props: any) => {
  return {
    ...props,
    properties: props.properties.filter((p: any) =>
      group.fields.includes(p.name)
    ),
  };
};

export const ObjectFieldTemplate = (props: any) => {
  // Separate alert destinations from other fields
  const alertDestField = props.properties.find(
    (element: any) => element.name === "alert_dest_list"
  );
  const nonAlertDestFields = props.properties.filter(
    (element: any) => element.name !== "alert_dest_list"
  );

  return (
    <div
      className="form-sections-container"
      style={{ display: "flex", gap: "2rem" }}
    >
      <div className="main-form-section" style={{ flex: "1 1 60%" }}>
        <div className="pulse-row">
          {nonAlertDestFields.map((element: any) => {
            const schema = element.content.props.schema;
            return element.name === "assets_include" ||
              element.name === "symbols_include" ||
              element.name === "account" ? (
              <div
                key={element.content.key}
                className="pulse-col-lg-6 form-col-full-width pulse-color--background-50"
                style={{ width: "50%" }}
              >
                {element.content}
              </div>
            ) : schema.title === "Value" ? (
              <div
                key={element.content.key}
                className="pulse-col-lg-6 form-col-full-width"
                style={{ width: "50%" }}
              >
                {element.content}
              </div>
            ) : !(
                schema.type === "object" ||
                (schema.type === "array" && schema.items.type === "object") ||
                "anyOf" in schema ||
                "oneOf" in schema
              ) ? (
              <div
                key={element.content.key}
                className="pulse-col-lg-6 form-col-full-width"
                style={{ width: "50%" }}
              >
                {element.content}
              </div>
            ) : (
              <div
                key={element.content.key}
                className="pulse-col-lg-6 form-col-full-width"
                style={{ width: "50%" }}
              >
                {element.content}
              </div>
            );
          })}
        </div>
      </div>

      {alertDestField && (
        <div
          className="alert-dest-section"
          style={{
            flex: "1 1 40%",
            borderLeft: "1px solid rgba(255, 255, 255, 0.12)",
            paddingLeft: "2rem",
          }}
        >
          <div className="pulse-row">
            <div className="pulse-col-lg-12 form-col-full-width">
              {alertDestField.content}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export const ObjectFieldTemplateWrapper = (props: any) => {
  const properties =
    props.schema && props.schema.properties
      ? Object.keys(props.schema.properties)
      : [];
  const GROUPS = [{ title: "All", fields: properties }];

  return (
    <>
      {GROUPS.map((group) => {
        const childProps = getPropsForGroup(group, props);
        return (
          <div key={group.title}>
            <ObjectFieldTemplate key={group.title} {...childProps} />
          </div>
        );
      })}
    </>
  );
};
